import { parrotListen } from './rad';
import dropdowns from './dropdowns';
import modals from './modals';
import listingBoxListener from './listing_box';

const globalListeners = () => {
	parrotListen();
	dropdowns();
	modals();
	listingBoxListener();
};

export default globalListeners;
